export function stringToColor(firstname?: string, id?: string) {
  if (!firstname || !id) return ''
  const name = firstname.slice(0, 2)
  let hash = 0
  let i

  const lastThreeChar = id.slice(id.length - 3)

  const finalString = name.concat(lastThreeChar)

  /* eslint-disable no-bitwise */
  for (i = 0; i < finalString.length; i += 1) {
    hash = finalString.charCodeAt(i) + ((hash << 5) - hash)
  }

  const lastDigit = hash % 10

  const LINEAR_ARRAY = [
    'linear-gradient(180deg, #8C8CD9 0.01%, #4040BF 100%)',
    'linear-gradient(180deg, #D9AC8C 0%, #BF7540 100%)',
    'linear-gradient(180deg, #D9CC8C 0%, #BFAA40 100%)',
    'linear-gradient(180deg, #8CD98C 0%, #40BF40 100%)',
    'linear-gradient(180deg, #8CD9CC 0%, #40BFAA 100%)',
    'linear-gradient(180deg, #8CBFD9 0.01%, #4095BF 100%)',
    'linear-gradient(180deg, #8C8CD9 0.01%, #4040BF 100%)',
    'linear-gradient(180deg, #BF8CD9 0%, #9540BF 100%)',
    'linear-gradient(180deg, #D98CBF 0%, #BF4095 100%)',
    'linear-gradient(180deg, #D98C8C 0%, #BF4040 100%)',
  ]
  return LINEAR_ARRAY[lastDigit]
}
